/**
 * Known English payment notes stored by Clinio Pay and refund reasons.
 * Swap the strings for the shared Danish copy helper when that lands (draft #481).
 */
const EXACT: Record<string, string> = {
  requested_by_customer: 'Anmodet af kunde',
  duplicate: 'Dobbelt betaling',
  fraudulent: 'Svindel',
  'Payment received via Clinio Pay': 'Betaling modtaget via Clinio Pay',
};

export function danishPaymentNote(note: string | null | undefined): string {
  if (!note) return '';
  const trimmed = note.trim();
  if (EXACT[trimmed]) return EXACT[trimmed];
  let text = note;
  for (const [english, danish] of Object.entries(EXACT)) {
    if (text.includes(english)) text = text.split(english).join(danish);
  }
  return text;
}
